import { useMemo } from "react"

import { useGeoServerFeaturesList } from "@l2r-front/l2r-geodata"

import { useNetworksStateContext, useRoleIsReadOnly } from "../contexts/NetworksContext"

import { useRoadSubNetworks } from "./useRoadSubNetworks"

export const useIsRoadWriter = (road: string | null | undefined, module: string) => {

    const { selectedNetwork, selectedSubNetworkSlugs } = useNetworksStateContext()
    const roadSubNetworks = useRoadSubNetworks(road)
    const readOnly = useRoleIsReadOnly(roadSubNetworks, module)

    const queryParams = {
        layer: selectedNetwork["referential"].layerSection,
        linear_location_road: road,
    }

    const { data: roadFeatures } = useGeoServerFeaturesList(
        ["road", selectedSubNetworkSlugs],
        {
            ...queryParams,
            as_geojson: true,
        },
        {
            enabled: !!road && !!selectedNetwork["referential"].layerSection,
        },
    )

    const isWriter = useMemo(() => {
        if (roadFeatures) {
            const roadSubNetworks = roadFeatures.features.reduce((acc, feature) => {
                if (feature.sub_network_slugs) {
                    feature.sub_network_slugs.forEach(subNetwork => {
                        acc.add(subNetwork)
                    })
                }
                return acc
            }, new Set())
            if (selectedSubNetworkSlugs.length && Array.from(roadSubNetworks).length) {
                const availableSubnetworksAllowsEdition = Array.from(roadSubNetworks)
                    .some(subNetwork => selectedSubNetworkSlugs.includes(subNetwork as string))
                return !readOnly && availableSubnetworksAllowsEdition
            }
            return !readOnly
        }
        return false
    }, [readOnly, roadFeatures, selectedSubNetworkSlugs])

    return isWriter
}